/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ScheduledValidatorBackupDto } from '../models/ScheduledValidatorBackupDto';
import type { ValidatorBackupDto } from '../models/ValidatorBackupDto';
import type { ValidatorBackupHistoryDto } from '../models/ValidatorBackupHistoryDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ValidatorBackupControllerService {

    /**
     * @param name
     * @returns ScheduledValidatorBackupDto OK
     * @throws ApiError
     */
    public static getBackupSchedule(
        name: string,
    ): CancelablePromise<ScheduledValidatorBackupDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/validators/{name}/backup',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @param requestBody
     * @returns ScheduledValidatorBackupDto OK
     * @throws ApiError
     */
    public static updateBackupSchedule(
        name: string,
        requestBody: ValidatorBackupDto,
    ): CancelablePromise<ScheduledValidatorBackupDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/validators/{name}/backup',
            path: {
                'name': name,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @param requestBody
     * @returns ScheduledValidatorBackupDto Created
     * @throws ApiError
     */
    public static createBackupSchedule(
        name: string,
        requestBody: ValidatorBackupDto,
    ): CancelablePromise<ScheduledValidatorBackupDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/validators/{name}/backup',
            path: {
                'name': name,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * @param name
     * @returns void
     * @throws ApiError
     */
    public static deleteBackupSchedule(
        name: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/validators/{name}/backup',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @returns ValidatorBackupHistoryDto OK
     * @throws ApiError
     */
    public static getBackupHistory(
        name: string,
    ): CancelablePromise<ValidatorBackupHistoryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/validators/{name}/backup/history',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

}
